/* @flow */
import gql from 'graphql-tag';
import apiRequest from './apiRequest';
import { apolloClient } from 'lib/graphql';

import type { GraphQLDocument } from 'lib/graphql';

export default class RemindAPI {
  static request(endpoint: string, method: string = 'GET', data: Object = {}, isJSON: boolean = true): Promise<*> {
    return apiRequest(endpoint, method, data, isJSON);
  }

  static execute(query: GraphQLDocument, variables: Object = {}): Promise<*> {
    const options = { query, variables };
    return apolloClient.query(options).then(({ data }) => data);
  }
}

export const ERRORS = {
  birthdate_required: 'birthdate_required',
  not_found: 'not_found',
  cannot_respond_to_closed_event: 'cannot_respond_to_closed_event',
};

if (__DEV__ && typeof window !== 'undefined') {
  window.apolloClient = apolloClient;
  window.gql = gql;
  window.RemindAPI = RemindAPI;
}



// WEBPACK FOOTER //
// ./src/lib/RemindAPI.js